<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>            
            <el-form-item label="所属代理商：">
                <el-input v-model.trim="searchForm.agentName"  @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
              <el-form-item label="运营商：">
                <el-input v-model="searchForm.alias" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="套餐名称 ：">
                <el-input v-model.trim="searchForm.packageName" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="号码：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="充值类型：">
                <el-select v-model="searchForm.investType" clearable>
                    <el-option label="首次充值" value="0"></el-option>
                    <el-option label="续费充值" value="1"></el-option>
                </el-select>
            </el-form-item>
          
            <!-- <el-form-item label="是否秒返：">
                <el-select v-model="searchForm.isCashback" clearable>
                    <el-option label="已秒返" value="2"></el-option>
                    <el-option label="未秒返" value="3"></el-option>
                    <el-option label="未开启" value="0"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getAgentOrderListHandle" plain icon="el-icon-search">查询查询</el-button>
                <!-- <el-button type="success" @click="exportAgentOrderInfoHandle" plain icon="el-icon-s-ticket">导出Excel</el-button> -->
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		> 
            <el-table-column prop="orderNo" label="订单号"  align="center"></el-table-column>
            <el-table-column prop="agentName" label="所属代理商"  align="center"></el-table-column>
            <el-table-column prop="iccid" label="号码"   width="180" align="center"></el-table-column>
            <el-table-column prop="intoNo" label="虚拟号" align="center"></el-table-column>
             <el-table-column  align="center"  label="套餐名称" >
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.orderNo">
                        <p style="color:#5c7eff"> {{scope.row.packageName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column prop="priceRmb" label="下单金额(元)"  align="center"></el-table-column>
            <el-table-column  align="center"  label="支付状态" >
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payState==1" class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:green"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else-if="scope.row.payState==3||scope.row.payState==4" class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:red"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:teal"> {{scope.row.payStateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
             <el-table-column prop="investTypeName" label="续费状态" width="180" align="center"></el-table-column>
             <el-table-column   align="center"  label="盈利(元)" width="70">
                    <template v-slot="scope">
                   <el-tooltip v-if="scope.row.payState==1"  :content="scope.row.orderNo">
                        <p style="color:hotpink"> {{scope.row.commissionRmb}}</p>
                    </el-tooltip>
                     <el-tooltip v-else  >
                        <p> 0</p>
                    </el-tooltip>
                     </template>
              </el-table-column>
            <el-table-column prop="alias" label="运营商" align="center"></el-table-column>
            <!-- <el-table-column prop="supplierTypeCodeName" label="卡来源" width="100" align="center"></el-table-column> -->
            <!-- <el-table-column prop="investTypeName" label="充值类型" width="100" align="center"></el-table-column> -->
            <el-table-column prop="createTime" label="下单时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showBackMoneyDialog(scope.row)" v-if="scope.row.payState==1 && scope.row.createType != 0 ">
						<span style="color: red;">
							申请退款
						</span>
					</el-button>
                </template>                
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
 <el-dialog :append-to-body="true"  title="退款申请" :visible.sync="backMoneyDialogVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订&nbsp;单&nbsp;号：</label>
                <span>{{rowData.orderNo}}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{rowData.iccid}}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{rowData.priceRmb}} 元</span>
            </div>

            <div class="lineInDialog">
                <label class="label-defined">付款凭证：</label>
                <div class="many">                    
                    <div class="uploadOuter">
                        <input type="file"  @change="showImg($event, 'existImg', 'payImg')" >
                        <div v-if="!existImg">点击上传付款凭证</div>
                        <img v-else :src="payImg" alt="">  
                    </div>
                </div>
            </div>
            <div class="lineInDialog">
                <label>退款原因：</label>
                <el-input  type="textarea" placeholder="请输入内容" :rows="5" v-model.trim="backMoneyForm.remark" clearable></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToBackMoney">取 消</el-button>
                <el-button type="primary" @click="handleBackMoney">申 请</el-button>
            </span>            
        </el-dialog>

        <el-dialog :append-to-body="true"  title="订单详情" :visible.sync="orderDetailVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订单号：</label>
                <span>{{orderDetailForm.orderNo}}</span>
            </div>
            <div class="lineInDialog">
                <label>所属代理商：</label>
                <span>{{orderDetailForm.agentName}}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{orderDetailForm.iccid}}</span>
            </div>
            <div class="lineInDialog">
                <label>套餐名称：</label>
                <span>{{orderDetailForm.packageName}}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{orderDetailForm.priceRmb}} 元</span>
            </div>
            <div class="lineInDialog">
                <label>支付状态：</label>
                <span>{{orderDetailForm.payStateName}}</span>
            </div>
            <div class="lineInDialog">
                <label>卡来源：</label>
                <span>{{orderDetailForm.supplierTypeCodeName}}</span>
            </div>
            <div class="lineInDialog">
                <label>我的佣金：</label>
                <span>{{orderDetailForm.commissionRmb}} 元</span>
            </div>
            <div class="lineInDialog">
                <label>下单时间：</label>
                <span>{{orderDetailForm.createTime}}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>            
        </el-dialog>   
    </div>
</template>
<script>
import {getAgentOrderList,exportAgentOrderInfo,backMoney} from '@/api/order.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                packageName: '',
                iccid: '',
                orderNo: '',
                investType: '',
                isCashback: '',
                time: ''
            },
            backMoneyForm:{},
            orderDetailVisible: false,
            orderDetailForm: {},
            backMoneyDialogVisible:false,
            rowData:[],
            existImg:false,
            payImg:'',
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
             formDate:{},
        }
    },
    methods: {
           showImg(event, showImgkey, imgUrl){
            this.$data[showImgkey] = true;
            this.existImg = true;
            const files = event.target.files;

            let filename = files[0].name          //只有一个文件
            if ( filename.lastIndexOf('.') <= 0 ) {
                return alert("Please add a valid image!")        //判断图片是否有效
            }
            const fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.addEventListener('load',() => {
                this.$data[imgUrl] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0];
            this.formDate.append('payImg', files[0]);
        },
           cancelToBackMoney(){
            this.backMoneyDialogVisible = false;
            this.formDate.delete('payImg');
            this.formDate.delete('orderId');
            this.formDate.delete('rqReason');
            this.rowData.id = '';
            this.backMoneyForm.remark = '';
            this.payImg = '';
            this.existImg = false;
        },
          //“退款操作” 对话框
        showBackMoneyDialog(row){


               this.$confirm('退款后 会扣除此订单产生的佣金，且每笔订单只能申请一次退款。确定提交退款申请吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
              this.backMoneyDialogVisible = true;
            this.rowData = row;
            }).catch(() => {

            });
            
        },
          handleBackMoney(){
            if(this.backMoneyForm.remark == ''){
                this.$message.error('请先输入退款原因！');
                return;
            }
            this.formDate.append('orderId', this.rowData.orderNo);
            this.formDate.append('rqReason', this.backMoneyForm.remark);

            this.$confirm('确定提交退款申请吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                backMoney(this.formDate).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                    }else{
                        this.$message.error(res.data.message)
                    }

                    this.formDate.delete('payImg');
                    this.formDate.delete('orderId');
                    this.formDate.delete('rqReason');
                    this.rowData.id = '';
                    this.backMoneyForm.remark = '';
                    this.payImg = '';
                    this.existImg = false;
                    this.backMoneyDialogVisible = false;

                    this.getAgentOrderListHandle();
                });
            }).catch(() => {

            });
            
        },
        getAgentOrderListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getAgentOrderList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showOrderDetail(row){
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentOrderListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getAgentOrderListHandle();
        },
        exportAgentOrderInfoHandle($event){//导出代理商微信订单
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            exportAgentOrderInfo(data).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
            }).catch(err=>console.error(err));     
        }        
    },
    created(){
          this.formDate = new FormData();
        this.getAgentOrderListHandle();
    }
}
</script>
<style lang="less" scoped>
  .label-defined{
        display: inline-block;
        height: 32px;
        line-height: 32px;
    }
     .many {
        display: flex;
        justify-content: space-between;
        label {
            display: block;
            line-height: 36px;
        }
        .uploadOuter {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 180px;
            min-height: 100px;
            max-height: 250px;
            border: 1px dashed #e5e5e5;
            box-sizing: border-box;
            input[type=file] {
                position: absolute;
                top: 0;
                width: 0;
                width: 50%;
                height: 100%;
                opacity: 0;
            }                
            img {
                width: 100%;
                height: 100%;
            }
        }
    }

</style>

